import React, { useEffect, useState } from 'react';
import { getExpressParams } from '../../../service/api';
import NoticeMain from '../../presentation/section/notice-page/NoticeMain';
import axios from 'axios';
import { connect } from 'react-redux'

const Notice = (props) => {
  const [pageNum, setPageNum] = useState(0);
  const [noticeContent, setNoticeContent] = useState([]);
  const [hasMoreNotice, setHasMoreNotice] = useState(true);
  const [loading, setLoading] = useState(false);

  const [noticeFilter, setNoticeFilter] = useState('');
  const [filteredArray, setFilteredArray] = useState([])
  const [userRole, setUserRole] = useState('');

  useEffect(() => {
    getExpressParams('/notice/all', {
      index: pageNum,
      isInsight: 0
    }, (response) => {
      for(const item of response.data) {
        setNoticeContent(noticeContent => [...noticeContent, item]);
        setFilteredArray(filteredContent => [...filteredContent, item])
      }
    })
    getExpressParams('/users/role/userid', {
      email: props.currentUser
    }, (response) => {
      setUserRole(response.data[0].role)
    })
  }, [])

  useEffect(() => {
    handleSearchBtn()
  }, [noticeContent])

  const handleSearchInput = (event) => {
    setNoticeFilter(event.target.value);
  }

  const handleSearchBtn = () => {
    if(!noticeFilter){
      handleResetBtn();
    }
    else{
      setFilteredArray([]);
      noticeContent.filter((item)=>{
        // return !noticeFilter || item.title.toLowerCase().startsWith(noticeFilter.toLowerCase())
        return !noticeFilter || item.title.toLowerCase().indexOf(noticeFilter.toLowerCase()) >= 0 || item.content.toLowerCase().indexOf(noticeFilter.toLowerCase()) >= 0
      }).forEach(
        (item) => {
          setFilteredArray(filteredContent => [...filteredContent, item])
        }
      )
    }

  }

  const handleResetBtn = () => {
    setFilteredArray([]);
    for(const item of noticeContent) {
      setFilteredArray(filteredContent => [...filteredContent, item])
    }
    setNoticeFilter('');
  }

  const loadNotice = async (page) => {
    if(!loading){
      await setLoading(true);
      await axios.get('/api/notice/all', {
        params: {
          index: pageNum+1,
          isInsight: 0
        }
      }).then((response) => {
        if (response.data.length == 0){
          setHasMoreNotice(false);
        }
        else{
          for(const item of response.data) {
            if(noticeContent.some(noticeItem=>{if(noticeItem.noticeID == item.noticeID){return true;}})){
  
            }
            else{
              setNoticeContent(noticeContent => [...noticeContent, item]);
            }
          }
        }
      })
      await setPageNum(pageNum=>pageNum+1)
      await setLoading(false);
    }
  }

  return (
    <>
      <NoticeMain noticeContent={noticeContent} loadNotice={loadNotice} hasMoreNotice={hasMoreNotice}
        filteredArray={filteredArray} setNoticeFilter={setNoticeFilter} noticeFilter={noticeFilter} handleSearchBtn={handleSearchBtn} handleSearchInput={handleSearchInput} handleResetBtn={handleResetBtn}
        userRole={userRole}
      />
      {/* <div dangerouslySetInnerHTML={{__html: code}}></div> */}
    </>
  )
}

const mapStateToProps = (state) => ({
  currentUser: state.AuthManager.status.currentUser
});
export default connect(mapStateToProps) (Notice);